import { createApi } from '@reduxjs/toolkit/query/react';
import { ServiceHistoryApi, ServiceHistoryFilter } from '../models';
import { PaginatedRequest, PaginatedResponse } from '@/types';
import { API_INVENTORY_URL } from '@/utils';
import { createBaseQueryWithReauth } from '@/services';

const serviceHistoryService = createApi({
  reducerPath: 'serviceHistoryService',
  baseQuery: createBaseQueryWithReauth(`${API_INVENTORY_URL}/service-history`),
  tagTypes: ['ServiceHistory', 'Assets'],
  endpoints: (builder) => ({
    getServiceHistory: builder.query<
      PaginatedResponse<ServiceHistoryApi>,
      { filters?: ServiceHistoryFilter; paginated: PaginatedRequest }
    >({
      query: ({ filters, paginated }) => {
        const params: Record<string, any> = {
          limit: paginated.pageSize,
          offset: (paginated.page - 1) * paginated.pageSize,
          populate: 'asset.brandDetails,asset.modelDetails,asset.typeDetails,asset.assetType,asset.user,supplier,assignedUser',
        };
        if (filters?.assetId) {
          params.assetId = filters.assetId;
        }
        if (filters?.barcode) {
          params.barcode = filters.barcode;
        }
        if (filters?.dateFrom) {
          params.dateFrom = filters.dateFrom.toISOString().split('T')[0];
        }
        if (filters?.dateTo) {
          params.dateTo = filters.dateTo.toISOString().split('T')[0];
        }
        return {
          url: '',
          params,
        };
      },
      providesTags: ['ServiceHistory'],
    }),
    createServiceHistory: builder.mutation({
      query: (body) => ({
        url: '',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['ServiceHistory', 'Assets'],
    }),
  }),
});

export default serviceHistoryService;
export const { useGetServiceHistoryQuery, useCreateServiceHistoryMutation } =
  serviceHistoryService;
